/**
 * Localized content helper.
 *
 * Some backend content is authored per-language so the UI can switch
 * instantly (no refetch) when the user toggles language. The backend
 * returns these fields as objects:
 *
 *   { fa: "بوتاکس پیشانی", en: "Forehead Botox" }
 *
 * This applies to dynamic CONTENT (service names, descriptions,
 * preparation notes) — distinct from UI chrome (labels, buttons), which
 * uses i18next `t()` keys. Categories use `t()` because they're a fixed
 * enum; service text is free-form per item, so it travels with the data.
 *
 * `localized` picks the active language with graceful fallback:
 *   - a plain string is returned as-is (back-compat / non-localized data)
 *   - a missing active-language value falls back to fa → en → ''
 *
 * @param {string|{fa?: string, en?: string}|null|undefined} field
 * @param {string} language  'fa' | 'en' (from Redux selectLanguage)
 * @returns {string}
 *
 * @example
 *   localized({ fa: 'الف', en: 'A' }, 'en')  // → 'A'
 *   localized({ fa: 'الف' }, 'en')           // → 'الف'  (falls back)
 *   localized('plain', 'en')                  // → 'plain'
 *   localized(null, 'en')                     // → ''
 */
export function localized(field, language) {
  if (field == null) return '';
  if (typeof field === 'string') return field;
  return field[language] || field.fa || field.en || '';
}

export default localized;
